import { ADD_CONTRACTS, ADD_PROGRAM, ADD_WORKS, LOADING_CONTRACT, LOADING_WORK, LOADING_PROGRAM, DOWNLOAD_REPORT, PERCENT_DOWNLOAD } from "app/actions/ComplianceMatrixbyPositionActions";

const initialState = {
    contracts: [],
    works: [],
    programs: [],
    isLoading: false,
    error: '',
    isLoadingContract: false,
    isLoadingWork: false,
    isLoadingProgram: false,

    download: {
        finish: false,
        message: "",
        fileName:"",
        url: "",
        idEmployee:"",
        regCreationDate:""
    },
    percent: 0
};

export const ComplianceMatrixbyPositionReducer = (state = initialState, action) => {

    switch ( action.type ) {
        case ADD_CONTRACTS:
            return {
                ...state,
                contracts: action.payload
            }
        case ADD_WORKS:
            return {
                ...state,
                works: action.payload
            }
        
        case ADD_PROGRAM:
            return {
                ...state,
                programs: action.payload 
            }
        
        case LOADING_CONTRACT:
            return {
                ...state,
                isLoadingContract: action.payload 
            } 
        
        case LOADING_WORK:
            return {
                ...state,
                isLoadingWork: action.payload 
            } 
        case LOADING_PROGRAM:
            return {
                ...state,
                isLoadingProgram: action.payload 
            }
        case DOWNLOAD_REPORT:
            return {
                ...state,
                download: action.payload.download
            }
        case PERCENT_DOWNLOAD: 
            return {
                ...state,
                percent: action.payload.percent
            }
        default:
            return state
    }
}